import { render, staticRenderFns } from "./OpenLeads.vue?vue&type=template&id=18bec386&scoped=true&lang=pug"
import script from "./OpenLeads.vue?vue&type=script&lang=js"
export * from "./OpenLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bec386",
  null
  
)

export default component.exports